var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgNoCamera(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    viewBox: "0 0 1440 810",
    height: 1080
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M767.219 11.652H221.527c-90.629 0-164.53 73.785-164.53 164.582v446.434c0 90.656 73.765 164.582 164.53 164.582H767.22c90.629 0 164.531-73.79 164.531-164.582V176.234c0-90.797-73.762-164.582-164.531-164.582zm108.316 611.016c0 59.66-48.535 108.348-108.316 108.348H221.527c-59.64 0-108.316-48.551-108.316-108.348V176.234c0-59.66 48.535-108.351 108.316-108.351H767.22c59.644 0 108.316 48.555 108.316 108.351zm0 0M1376.805 136.871c-14.258-9.601-32.356-11.52-48.125-4.937l-259.27 106.43c-20.43 8.366-33.73 28.667-33.73 51.706V512.81c0 23.039 13.164 43.203 33.73 51.707l259.27 106.43c6.308 2.605 12.89 3.84 19.472 3.84 10.008 0 20.153-3.02 28.79-8.778 15.359-10.29 24.406-27.707 24.406-46.77V183.641c-.137-19.063-9.325-36.485-24.543-46.77zm-31.809 479.762l-253.238-103.824V289.934v-.137l253.238-103.824zm0 0"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    strokeLinecap: "round",
    transform: "matrix(48.70988 -28.12266 28.14845 48.75455 30.5 793.37)",
    fill: "none",
    d: "M.5 0h26.576",
    stroke: "#fff"
  })));
}
export default SvgNoCamera;